import './StatusBadge.css'

import { getConversationStatusVariant } from '../../../../utils/statusVariants'

/**
 * Badge colorata per visualizzare lo stato di una conversazione.
 * Usa le classi `.nora-status` del design system Nora.
 * @param {Object} props - Proprietà del componente
 * @param {Object} props.processState - Stato del processo {label, value}
 * @param {string} [props.status] - Status della conversazione (open, paused, error, ecc.)
 * @param {Object} [props.conv] - Oggetto conversazione/riga per calcolo variante
 * @returns {JSX.Element} Componente badge stato
 */
export function StatusBadge({ processState, status, conv }) {
  if (!processState) {
    return <span className="nora-status nora-status--neutral">-</span>
  }

  const isPaused = status === 'paused'
  const variant = getConversationStatusVariant(conv || { status, processState }, status)

  return (
    <span className={`nora-status nora-status--${variant}`} title={processState.label}>
      {isPaused && <i className="pi pi-exclamation-circle gigi-status-warning-icon" />}
      <span className="nora-status__dot" />
      <span className="nora-status__label">{processState.label}</span>
    </span>
  )
}
